import styled from 'styled-components';

export const Content = styled.div`
  max-width: 280px;
  font-size: 15px;
  text-align: center;
  p {
    margin: 15px 0;
    line-height: 1.3;
  }
`;

export const Fields = styled.div`
  margin: 0 0 15px;
`;

export const Block = styled.div`
  margin: 0 0 10px;
  label {
    color: #fff;
    display: block;
    margin: 0 0 5px;
  }
  select {
    /* padding: 5px; */
    border-radius: 4px;
    height: 28px;
    box-sizing: border-box;
    max-width: 100%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input {
    border-radius: 4px;
    box-sizing: border-box;
    height: 28px;
    padding: 5px;
    width: 100%;
    display: block;
  }
`;
